import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Redirect, Link } from "react-router-dom";
import * as AuthenticationUtil from "../util/AuthenticationUtil";

import { useForm } from "react-hook-form";

import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";

import { usePageLoader } from "../util/usePageLoader";
import { useAlert } from "../util/useAlert";

import * as Endpoints from "../util/Endpoints";
import * as ApiUtil from "../util/ApiUtil";
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@material-ui/core";
import { Grid } from "@material-ui/core";

export const RegisterPersonNumber = ({
  regionList = [{}],
  siteList = [{}],
}) => {
  const [region, setRegion] = useState();
  const [site, setSite] = useState();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const history = useHistory();

  const [redirectUrl, setRedirectUrl] = useState();
  const [proceedRedirect, setProceedRedirect] = useState();

  const [loader, showLoader, hideLoader] = usePageLoader();
  const [alert, showAlert] = useAlert();

  if (AuthenticationUtil.isAuthenticated()) {
    return <Redirect to="/questionnaire" />;
  }

  /* const registerUser = async (data) => {

        try {
            showLoader();
            const responseData = await ApiUtil.callBackend(Endpoints.registerUser + data.mobileNumber, "POST");
            console.log(responseData);

            if (responseData.status) {
                showAlert(responseData.message, "success");
                history.push("/login");
            } else {
                showAlert(responseData.message, "error");
            }
        } catch (error) {
            console.log(error);
            showAlert(error.message, "error");
        } finally {
            hideLoader();
        }
    } */

  const registerUser = async (data) => {
    try {
      showLoader();
      const responseData = await ApiUtil.callBackend(
        Endpoints.registerUserPersonNumber,
        "POST",
        {
          personalNumber: data.personNumber,
          password: data.password,
          firstName: data.firstName,
          lastName: data.lastName,
          regionId: "",
          siteId: "",
        }
      );
      console.log(responseData);

      if (responseData.status) {
        showAlert(responseData.message, "success");
      } else {
        showAlert(responseData.message, "error");
      }
    } catch (error) {
      console.log(error);
      showAlert(error.message, "error");
      return;
    } finally {
      hideLoader();
    }
  };

  if (proceedRedirect && redirectUrl) {
    window.location = redirectUrl;
  }

  // const handleSiteChange = (event, object) => {
  //   //localStorage.setItem("siteId", event.target.value);
  //   setSite(event.target.value);
  // };

  // const handleRegionChange = (event, object) => {
  //   //localStorage.setItem("regionId", event.target.value);
  //   setRegion(event.target.value);
  // };

  return (
    <>
     
      {loader}
      {alert}
    </>
  );
};
